// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1nouV","footer":"ModalCreateQualiphyProcedure_footer__19I0N","additionData":"ModalCreateQualiphyProcedure_additionData__3LPJr"};